import { useQuery } from "@tanstack/react-query";

import { materialsVolumetricPriceQuery } from "#modules/materials/infra/materialsVolumetricPrice.query";

export const useMaterialsVolumetricPrice = () => {
  const { data, ...rest } = useQuery({
    ...materialsVolumetricPriceQuery(),
  });

  return { materialsVolumetricPrice: data, ...rest };
};
